import {apiUrl} from '../utils/constants';
import {DELETE, GET, PATCH, POST, PUT} from './api.service.wrapper';


export const GetGoLiveFormRequest = async (keyword = '', page = '', perPage = '', is_paginate = true, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }

    if (keyword) {
        params['search'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.go_live_form_request, params);
    return response;
}

export const GetGoLiveFormById = async (id) => {
    let response = '';
    response = await GET(apiUrl.go_live_form_request + '/' + id);
    return response;
}

export const AddGoLiveForm = async (data) => {
    const response = await POST(apiUrl.go_live_form_request, data);
    return response;
}

export const UpdateGoLiveForm = async (id, data) => {
    const response = await PATCH(apiUrl.go_live_form_request, id, data);
    return response;
}

export const DeleteGoLiveForm = async (id) => {
    const response = await DELETE(apiUrl.go_live_form_request, id);
    return response;
}
